import { useTranslation } from 'next-i18next';
import type { FC } from 'react';

import StatusMessageBox from 'components/StatusMessageBox';

const AddDevicesToGroupsSuccess: FC = () => {
  const { t } = useTranslation();

  return (
    <StatusMessageBox
      type="success"
      message={t(
        'common:pages.rfid_groups.add_rfid_group.rfids_added_to_groups',
      )}
    />
  );
};

export default AddDevicesToGroupsSuccess;
